import React from 'react';
import {BUTTON_TYPES} from "../../types";
import clsx from "clsx";
import {GoogleLogo} from "../icons";

const Button = (
  { title, onClick, className, type = BUTTON_TYPES.PRIMARY, disabled = false }:
  { title: string; onClick?: () => void; className?: string; type?: string; disabled?: boolean}
) => {

  const buttonType: {[key: string]: string} = {
    primary: "bg-black text-white",
    secondary: "bg-yellow text-black",
    gray: "bg-mainBlack/5 text-black",
    google: "bg-white border border-solid border-mainBlack",
    error: "bg-rose-700 border border-solid border-rose-900",
    success: "bg-emerald-700 border border-solid border-emerald-900",
  }

  return (
    <button
      onClick={onClick}
      type="submit"
      className={
        clsx(
          "flex items-center justify-center py-2 px-[32px] text-sm leading-[16px] rounded-sm font-medium cursor-pointer hover:opacity-50 duration-150 easy-in",
          className,
          buttonType[type],
          disabled && "opacity-30 cursor-not-allowed hover:opacity-30"
        )
      }
    >
      {type === BUTTON_TYPES.GOOGLE && <GoogleLogo className="mr-[6px]" />}
      {title}
    </button>
  )
};

export default Button;
